import {
    Wrapper,
    Image,
    MainContent,
    Heading,
    Description
} from './HowMuchIsMyHomeWorth.styles';
import { ZooplaPeak22767 } from '@zoopla/assets';

import { GetHomeWorthEstimateForm } from '@zoopla/home-worth-estimate-form';

const headlineText = 'Ready to move on?';
const descriptionText =
    'Get our latest estimate on your property. You might be surprised what you could get for it.';

const dimensions = { width: 1300, height: 776 };

export const HowMuchIsMyHomeWorth = () => {
    return (
        <Wrapper>
            <Image
                src={ZooplaPeak22767}
                width={dimensions.width}
                height={dimensions.height}
                alt=""
                loading="lazy"
            />
            <MainContent>
                <Heading size="4" id="home-values-title">
                    {headlineText}
                </Heading>
                <Description>{descriptionText}</Description>
                <GetHomeWorthEstimateForm
                    eventCategory="homepage"
                    labelId="home-values-title"
                />
            </MainContent>
        </Wrapper>
    );
};
